import { render, staticRenderFns } from "./MyHeroesPage.vue?vue&type=template&id=587fe6f4&"
import script from "./MyHeroesPage.vue?vue&type=script&lang=js&"
export * from "./MyHeroesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports